import React from 'react';
import { match } from 'variant';
import { Box } from 'ink';
import type { InputState } from '../../input-state.js';
import { Text } from '../Text.js';
import type { SelectOption } from './types.js';
import { SuccessIcon } from '../../icons/Success.js';

interface Props<T> {
  inputState: InputState<SelectOption<T>>;
}

export function Placeholder<T>({ inputState }: Props<T>) {
  return match(inputState, {
    NotSubmitted: () => null,
    Submitted: ({ value }) => (
      <Box marginBottom={1}>
        <Text skin="secondary">
          <SuccessIcon /> {value.title}
        </Text>
      </Box>
    ),
  });
}
